import React from 'react';
import PageHeader from '../components/HeroSection';
import ContactSection from '../components/ContactSection';
import BookSection from '../components/BookSection';
import ServicesSection from '../components/ServicesSection';
import PricingSection from '../components/PricingSection';
import TreatmentsSection from '../components/TreatmentsSection';
import { Helmet } from 'react-helmet';
const ServicesPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Helmet>
  <title>Hair Extension, Color & Cut Services | Easton, PA Salon</title>
  <meta name="description" content="Explore our services including hand-tied extensions, balayage, highlights, precision cuts, and more. View pricing and book your stylist." />
  <meta property="og:title" content="Hair Services | Extensions, Color & Cuts in Easton" />
  <meta property="og:description" content="From extensions to color correction, our Easton salon offers personalized services for your perfect look." />
  <meta property="og:url" content="https://www.hairtodyeforeaston.com/services" />
  <meta property="og:type" content="website" />
  <meta name="keywords" content="hair services Easton PA, hand-tied extensions, balayage Easton, hair cuts Easton, hair salon services" />
  <link rel="canonical" href="https://www.hairtodyeforeaston.com/services" />
</Helmet>
      {/* Page Header with Hero */}
      <PageHeader pageTitle="SERVICES" />

      {/* Services Section - Hero and Artists */}
      <ServicesSection />
      {/* All Artists Image */}
   <div className="w-full px-4 sm:px-8 md:px-12 lg:px-20">
    <h1 className="sr-only">Professional Hair Services in Easton</h1>
  <img 
    src="images/Artists/all_Artists.webp" 
    alt="All Artists" 
    className="w-full h-auto object-cover"
  />
</div>
      {/* Pricing Section - Haircuts & Color Services */}
      <PricingSection />

      {/* Deep Care Treatments Section */}
      <TreatmentsSection />

      {/* Book Section */}
      <BookSection />

      {/* Contact Section */}
      <ContactSection />
    </div>
  );
};

export default ServicesPage;